import { CircularProgress, TablePagination } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { invokeApi } from "../../../../bl_libs/invokeApi";
import CancelRequestsFilter from "./CancelRequestsFilter";
import moment from "moment";

function CancelRequests(props) {
  const [requests, SetRequests] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getStatusForCompany = (status) => {
    if (status === 0) {
      return "New Request";
    }
    if (status === 1) {
      return "Bid submited";
    }
    if (status === 2) {
      return "Bid accepted";
    }
    if (status === 3) {
      return "Paid and waiting for move";
    }
    if (status === 4) {
      return "Truck assigned and ready to move";
    }
    if (status === 5) {
      return "Move in progress";
    }
    if (status === 6) {
      return "Completed, waiting for confirmation";
    }
    if (status === 7) {
      return "Completed";
    }
    if (status === 8) {
      return "Feedback Given";
    }
    if (status === 11) {
      return "Bid Cancelled";
    }
  };
  //filter state management
  const [filters, setFilters] = useState(localStorage.getItem("foremanReqCancelFilter")
  ? JSON.parse(localStorage.getItem("foremanReqCancelFilter"))
  : {
    from_date: "",
    to_date: "",
    schedule: "",
    distance: "",
    move_type: "",
    truck_name: "",
  });
  const [moveSizeList, setMoveSizeList] = useState([]);
  const [truckList, setTruckList] = useState([]);

  const [isFilter, setIsFilter] = useState(localStorage.getItem("foremanReqCancelFilter")?true:false);

  //------------------------------------------>  pagination settings

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [totalCount, setTotalCount] = useState(0);
  //----------------------------------------------------------------

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  //////////////////////////////////////////////////////////////////

  const fetchCancelledRequests = (type) => {
    let requestObj = {
      path: `/api/foreman/get_foreman_request?page=${page}&limit=${rowsPerPage}`,
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };

    let postData = {};
    if (type === "filter") {
      setIsFilter(true);
      postData = {
        request_status: "2",
        filter_status: "2",
        from_date:
          filters.from_date === ""
            ? ""
            : moment(filters.from_date).format("MM-DD-YYYY"),
        to_date:
          filters.to_date === ""
            ? ""
            : moment(filters.to_date).format("MM-DD-YYYY"),
        time: filters.schedule,
        min_distance:
          filters.distance === "" ? "" : filters.distance.split("-")[0],
        max_distance:
          filters.distance === "" ? "" : filters.distance.split("-")[1],
        move_type: filters.move_type,
        truck_name: filters.truck_name,
      };
    } else {
      setIsFilter(false);
      //if type is undefined
      //we are not passing filters in API
      postData = {
        request_status: "2",
      };
    }
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      console.log(res);
      if (res.code === 200) {
        props.setCounts({
          ...props.counts,
          activeCount: res.request_count.active_request_count,
          doneCount: res.request_count.done_request_count,
          cancelCount: res.request_count.cancle_request_count
        });
        SetRequests(res.data);
        setTotalCount(res.get_request_count);
        setIsLoading(false);
      }
    });
  };

  const fetchTruckList = () => {
    let requestObj = {
      path: "/api/foreman/get_truck_for_foreman",
      method: "GET",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        console.log(res.data);
        setTruckList(res.data.allTruck);
      }
    });
  };

  const fetchListForMoverType = () => {
    let requestObj = {
      path: "/api/customer/get_move_type",
      method: "GET",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    invokeApi(requestObj).then((res) => {
      console.log(res, "MOVE SIZE RESPONSCE");
      if (res.code === 200) {
        setMoveSizeList(res.data.moveTypeItems);
      }
    });
  };

  useEffect(() => {
    if (isFilter) {
      fetchCancelledRequests("filter");
    } else {
      fetchCancelledRequests();
    }
  }, [rowsPerPage, page]);

  useEffect(() => {
    fetchListForMoverType();
    fetchTruckList();
  }, []);
  ////////////////////////////////////////////
  useEffect(() => {
    localStorage.setItem("directReqCancelFilter", JSON.stringify(filters));
    let date;
    if (filters.from_date !== "" && filters.to_date !== "") {
      date = `${moment(filters.from_date).format("ll")} to ${moment(
        filters.to_date
      ).format("ll")}`;
    } else {
      date = "";
    }
    let truck = truckList.map((truck) => {
      if (filters.truck_name == truck.id) {
        return truck.name;
      }
      return "";
    });
    props.setCancelFilterTitles([
      date,
      filters.schedule,
      filters.distance !== "" ? filters.distance + " miles" : filters.distance,
      filters.move_type,
      truck[0],
    ]);
  }, [filters,truckList]);
  //////////////////////////////////////////////////////////////////////
 
  if (isLoading) {
    return (
      <>
        <div className="Circular-Progress ">
          <CircularProgress />
        </div>
      </>
    );
  }
  // if (requests.length === 0) {
  //   return <div>No request found</div>;
  // }

  if (window.innerWidth < 500) {
    console.log(window.innerWidth, "Width");
    return (
      <>
        <div className="rounded-box pb-3">
          <div className="row">
            <div className="col-12">
              <table
                id="example"
                className="responsive table table-hover"
                style={{ width: "100%" }}
              >
                <thead>
                  <th className="small-sub-title dark-grey-color">
                    <div className="row">
                      <div className="col-6 small-sub-title dark-grey-color">
                        Cancelled Requests
                      </div>
                      <div className="col-6">
                        {/* #{request.request_data.id} */}
                      </div>
                    </div>
                  </th>
                </thead>
                <tbody>
                  {requests.map((request, i) => (
                    <tr
                      key={request.foreman_requests.id}
                      className="pointer-point border-bottom"
                    >
                      <div className="row pl-2 mt-2">
                        <div className="col-4 small-sub-title dark-grey-color">
                          Request No.
                        </div>
                        <div className="col-8 small-sub-title dark-grey-color">
                          #{request.foreman_requests.id}
                          <span className="mr-2 float-right">
                            {request.foreman_requests.request_type && (
                              <span className="custom-chip">Direct</span>
                            )}
                          </span>
                        </div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Start date:</span>
                        </div>
                        <div className="col-8">
                          {request.foreman_requests.schedule_time.slice(0, 11)}
                        </div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Start time:</span>
                        </div>
                        <div className="col-8">
                          {request.foreman_requests.schedule_time.slice(
                            11,
                            request.foreman_requests.schedule_time.length
                          )}
                        </div>

                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Distance:</span>
                        </div>
                        <div className="col-8">
                          {request.foreman_requests.net_distance} mi
                        </div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Move Type:</span>
                        </div>
                        <div className="col-8">
                          {request.foreman_requests.move_type}
                        </div>

                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Truck:</span>
                        </div>
                        <div className="col-8">
                          {request.trcuk_array.length === 0
                            ? "-"
                            : request.trcuk_array.map((truck, i) => {
                                return (
                                  truck.name +
                                  (i === request.trcuk_array.length - 1
                                    ? ""
                                    : ", ")
                                );
                              })}
                        </div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Status:</span>
                        </div>
                        <div className="col-8">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="8" cy="8" r="8" fill="#C4314B"></circle>
                          </svg>{" "}
                          {getStatusForCompany(
                            request.foreman_requests.request_timeline_status
                          )}
                        </div>
                        <div className="col-4 small-sub-title dark-grey-color">
                          <span className="">Last update:</span>
                        </div>
                        <div className="col-8">
                          <span className="light-grey-color extra-small-font-size">
                            Updated{" "}
                            {moment(
                              request.foreman_requests.updated_at
                            ).fromNow()}
                          </span>
                        </div>
                      </div>
                    </tr>
                  ))}
                </tbody>
              </table>
              <TablePagination
                component="div"
                count={totalCount}
                page={page}
                onChangePage={handleChangePage}
                rowsPerPage={rowsPerPage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage={
                  <span className="pagination-text">Rows:</span>
                }
              />
            </div>
          </div>
        </div>
        <CancelRequestsFilter
          filters={filters}
          setFilters={setFilters}
          moveSizeList={moveSizeList}
          truckList={truckList}
          setPage={setPage}
          fetchCancelledRequests={fetchCancelledRequests}
        />
      </>
    );
  }

  return (
    <>
      <div className="rounded-box pb-3">
        <div className="row">
          <div className="col-12">
            <table
              id="example"
              className="responsive table table-hover"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th className="small-sub-title dark-grey-color">
                    Request number
                  </th>
                  <th className="small-sub-title dark-grey-color">
                    Start date and time
                  </th>
                  <th className="small-sub-title dark-grey-color">Status</th>
                  <th className="small-sub-title dark-grey-color">Distance</th>
                  <th className="small-sub-title dark-grey-color">Move Type</th>
                  <th className="small-sub-title dark-grey-color">Truck</th>
                  <th className="small-sub-title dark-grey-color"></th>
                </tr>
              </thead>
              <tbody>
                {requests.map((request, i) => (
                  <tr
                    key={i}
                    className="pointer-point"
                    // onClick={() =>
                    //   props.history.push(
                    //     "/company/foreman-requests/" + request.request_data.id
                    //   )
                    // }
                  >
                    <td>
                      <span
                        href="request-detail-submitted.html"
                        className="request-link"
                      >
                        #{request.foreman_requests.id}
                        <span className="ml-3">
                          {request.foreman_requests.request_type && (
                            <span className="custom-chip">Direct</span>
                          )}
                        </span>
                        <br />
                        <span className="light-grey-color extra-small-font-size">
                          Updated{" "}
                          {moment(
                            request.foreman_requests.updated_at
                          ).fromNow()}
                        </span>
                      </span>
                    </td>
                    <td>
                      {request.foreman_requests.schedule_time}
                      <br />
                      {/* 9:00 AM */}
                    </td>
                    <td>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="8" cy="8" r="8" fill="#C4314B"></circle>
                      </svg>{" "}
                      {getStatusForCompany(
                        request.foreman_requests.request_timeline_status
                      )}
                      <br />
                      <span className="light-grey-color extra-small-font-size">
                        {moment(request.foreman_requests.updated_at).format(
                          "MMM Do YY , hh:mm"
                        )}
                      </span>
                    </td>
                    <td>{request.foreman_requests.net_distance} mi</td>
                    <td>{request.foreman_requests.move_type}</td>
                    <td>
                      {request.trcuk_array.map(
                        (truck, i) =>
                          truck.name +
                          (i === request.trcuk_array.length - 1 ? "" : ", ")
                      )}
                    </td>
                    <td>
                      <a className="custom-btn-small custom-button-extra-small req-status-button status-button-cancelled">
                        Cancelled
                      </a>
                    </td>
                  </tr>
                ))}
                {/* loop Close */}
              </tbody>
            </table>
            <TablePagination
              component="div"
              count={totalCount}
              page={page}
              onChangePage={handleChangePage}
              rowsPerPage={rowsPerPage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              labelRowsPerPage={
                <span className="pagination-text">Rows per page:</span>
              }
            />
          </div>
        </div>
      </div>
      <CancelRequestsFilter
        filters={filters}
        setFilters={setFilters}
        moveSizeList={moveSizeList}
        truckList={truckList}
        setPage={setPage}
        fetchCancelledRequests={fetchCancelledRequests}
      />
    </>
  );
}

export default CancelRequests;
